import { SupportedLanguage } from '../types/language.types';
const NOTES = {
    [SupportedLanguage.DE]: {
        executionBatch: 'Die Zeichnung wird nicht sofort ausgeführt: Sie wird gesammelt und zum nächsten Bewertungsstichtag zu einem einheitlichen Kurs abgerechnet.',
        executionImmediate: 'Die Zeichnung wird sofort über Tradevest ausgeführt und von deinem Verrechnungskonto belastet.',
        unitsEstimated: 'Die Anzahl der Token steht erst mit der Abrechnung fest. Der angezeigte Wert ist eine Schätzung.',
        cancellable: 'Solange die Zeichnung nicht abgerechnet ist, kannst du sie in der App stornieren.',
        withdrawal: days => `Dir steht ein Widerrufsrecht von ${days} Tagen zu. Die Einzelheiten stehen in der Widerrufsbelehrung.`,
        redemptionBatch: 'Die Rückgabe wird nicht sofort ausgeführt: Sie wird gesammelt und zum nächsten Bewertungsstichtag zu einem einheitlichen Kurs abgerechnet.',
        saleImmediate: 'Der Verkauf wird sofort über Tradevest ausgeführt.',
        proceedsEstimated: 'Der Erlös steht erst mit der Abrechnung fest. Der angezeigte Wert ist eine Schätzung.',
        redemptionCancellable: 'Solange die Rückgabe nicht abgerechnet ist, kannst du sie in der App stornieren.',
        payoutAfterSettlement: 'Der Erlös wird nach der Abrechnung deinem Verrechnungskonto gutgeschrieben.',
        payoutImmediate: 'Der Erlös wird deinem Verrechnungskonto gutgeschrieben.',
        orderResting: 'Dein Auftrag liegt im laufenden Sammelauftrag und wird zum nächsten Bewertungsstichtag abgerechnet.',
        orderSettled: 'Der Auftrag wurde zum Kurs des Bewertungsstichtags abgerechnet.',
        orderWithdrawn: 'Der Auftrag wurde zurückgenommen. Der reservierte Betrag wird wieder freigegeben.',
        orderExpired: 'Der Sammelauftrag wurde geschlossen, ohne dass dein Auftrag ausgeführt wurde. Der reservierte Betrag wird wieder freigegeben.',
    },
    [SupportedLanguage.EN]: {
        executionBatch: 'The subscription is not executed immediately: it is collected and settled at one uniform price at the next valuation point.',
        executionImmediate: 'The subscription is executed at Tradevest as it is placed and charged to your settlement account.',
        unitsEstimated: 'The number of tokens is set at settlement. The figure shown is an estimate.',
        cancellable: 'Until it settles, you can withdraw the subscription in the app.',
        withdrawal: days => `You have a statutory right of withdrawal of ${days} days. The withdrawal instructions state the details.`,
        redemptionBatch: 'The redemption is not executed immediately: it is collected and settled at one uniform price at the next valuation point.',
        saleImmediate: 'The sale is executed at Tradevest as it is placed.',
        proceedsEstimated: 'The proceeds are set at settlement. The figure shown is an estimate.',
        redemptionCancellable: 'Until it settles, you can withdraw the redemption in the app.',
        payoutAfterSettlement: 'The proceeds are credited to your settlement account once the redemption has settled.',
        payoutImmediate: 'The proceeds are credited to your settlement account.',
        orderResting: 'Your order is in the open batch and will settle at the next valuation point.',
        orderSettled: 'The order settled at the price of the valuation point.',
        orderWithdrawn: 'The order was withdrawn. The reserved amount is released again.',
        orderExpired: 'The batch closed without your order being executed. The reserved amount is released again.',
    },
    [SupportedLanguage.RU]: {
        executionBatch: 'Подписка исполняется не сразу: она собирается и рассчитывается по единому курсу на ближайший день оценки.',
        executionImmediate: 'Подписка исполняется в Tradevest сразу и списывается с твоего расчётного счёта.',
        unitsEstimated: 'Количество токенов определяется при расчёте. Показанное значение — оценка.',
        cancellable: 'Пока подписка не рассчитана, её можно отозвать в приложении.',
        withdrawal: days => `У тебя есть право отказа в течение ${days} дней. Подробности — в разъяснении о праве отказа.`,
        redemptionBatch: 'Погашение исполняется не сразу: оно собирается и рассчитывается по единому курсу на ближайший день оценки.',
        saleImmediate: 'Продажа исполняется в Tradevest сразу.',
        proceedsEstimated: 'Сумма к получению определяется при расчёте. Показанное значение — оценка.',
        redemptionCancellable: 'Пока погашение не рассчитано, его можно отозвать в приложении.',
        payoutAfterSettlement: 'Сумма будет зачислена на твой расчётный счёт после расчёта.',
        payoutImmediate: 'Сумма будет зачислена на твой расчётный счёт.',
        orderResting: 'Твой ордер в текущем сборном поручении и будет рассчитан на ближайший день оценки.',
        orderSettled: 'Ордер рассчитан по курсу дня оценки.',
        orderWithdrawn: 'Ордер отозван. Зарезервированная сумма будет возвращена.',
        orderExpired: 'Сборное поручение закрылось, а твой ордер исполнен не был. Зарезервированная сумма будет возвращена.',
    },
    [SupportedLanguage.PL]: {
        executionBatch: 'Subskrypcja nie jest realizowana natychmiast: jest zbierana i rozliczana po jednolitym kursie w najbliższym dniu wyceny.',
        executionImmediate: 'Subskrypcja jest realizowana w Tradevest od razu i obciąża Twoje konto rozliczeniowe.',
        unitsEstimated: 'Liczba tokenów zostaje ustalona przy rozliczeniu. Pokazana wartość jest szacunkiem.',
        cancellable: 'Dopóki subskrypcja nie zostanie rozliczona, możesz ją wycofać w aplikacji.',
        withdrawal: days => `Przysługuje Ci prawo odstąpienia w terminie ${days} dni. Szczegóły znajdziesz w pouczeniu o odstąpieniu.`,
        redemptionBatch: 'Umorzenie nie jest realizowane natychmiast: jest zbierane i rozliczane po jednolitym kursie w najbliższym dniu wyceny.',
        saleImmediate: 'Sprzedaż jest realizowana w Tradevest od razu.',
        proceedsEstimated: 'Kwota do wypłaty zostaje ustalona przy rozliczeniu. Pokazana wartość jest szacunkiem.',
        redemptionCancellable: 'Dopóki umorzenie nie zostanie rozliczone, możesz je wycofać w aplikacji.',
        payoutAfterSettlement: 'Kwota zostanie zaksięgowana na Twoim koncie rozliczeniowym po rozliczeniu.',
        payoutImmediate: 'Kwota zostanie zaksięgowana na Twoim koncie rozliczeniowym.',
        orderResting: 'Twoje zlecenie jest w otwartym zbiorze i zostanie rozliczone w najbliższym dniu wyceny.',
        orderSettled: 'Zlecenie zostało rozliczone po kursie dnia wyceny.',
        orderWithdrawn: 'Zlecenie zostało wycofane. Zarezerwowana kwota zostanie zwolniona.',
        orderExpired: 'Zbiór został zamknięty bez realizacji Twojego zlecenia. Zarezerwowana kwota zostanie zwolniona.',
    },
};
const DEFAULT_LANGUAGE = SupportedLanguage.DE;
function languageOf(requested) {
    const wanted = (requested ?? '').trim().toLowerCase();
    const known = Object.values(SupportedLanguage).find(language => language === wanted);
    return known ?? DEFAULT_LANGUAGE;
}
export function rwaTradingNotes(terms, language) {
    const copy = NOTES[languageOf(language)];
    const notes = {
        execution: terms.execution === 'batch' ? copy.executionBatch : copy.executionImmediate,
    };
    if (!terms.unitsKnownUpfront)
        notes.units = copy.unitsEstimated;
    if (terms.cancellable)
        notes.cancellation = copy.cancellable;
    if (typeof terms.withdrawalRightDays === 'number' && terms.withdrawalRightDays > 0) {
        notes.withdrawal = copy.withdrawal(terms.withdrawalRightDays);
    }
    return notes;
}
export function rwaRedemptionNotes(terms, language) {
    const copy = NOTES[languageOf(language)];
    const batch = terms.execution === 'batch';
    const notes = {
        execution: batch ? copy.redemptionBatch : copy.saleImmediate,
        payout: batch ? copy.payoutAfterSettlement : copy.payoutImmediate,
    };
    if (!terms.unitsKnownUpfront)
        notes.proceeds = copy.proceedsEstimated;
    if (terms.cancellable)
        notes.cancellation = copy.redemptionCancellable;
    return notes;
}
export function tokenizedOrderNote(status, language) {
    const copy = NOTES[languageOf(language)];
    if (status === 'RECEIVED' || status === 'PENDING')
        return copy.orderResting;
    if (status === 'FILLED' || status === 'SETTLED' || status === 'CORRECTED')
        return copy.orderSettled;
    if (status === 'CANCELED' || status === 'CANCELLED' || status === 'PARTIALLY_FILLED_CANCELLED') {
        return copy.orderWithdrawn;
    }
    if (status === 'EXPIRED' || status === 'PARTIALLY_FILLED_EXPIRED')
        return copy.orderExpired;
    return undefined;
}
//# sourceMappingURL=rwa-trading-notes.utils.js.map